import { TileSize } from "game-common/models"

export interface RenderPosition { x: number; y: number; ts: number }

/** Frame-rate independent easing shared by active and observed floors. */
export function smoothRenderPosition(state: RenderPosition | undefined, x: number, y: number, now: number): RenderPosition {
    if (!state) return { x, y, ts: now }
    const elapsed = now - state.ts
    state.ts = now
    const dx = x - state.x, dy = y - state.y
    const distanceSq = dx * dx + dy * dy
    // Large corrections are teleports. Settle within a quarter pixel so a stopped
    // character finishes walking instead of animating ever-smaller steps forever.
    if (elapsed <= 0 || distanceSq > TileSize * TileSize || distanceSq < .25 * .25) {
        state.x = x
        state.y = y
    } else {
        const alpha = 1 - Math.exp(-elapsed / 55)
        state.x += dx * alpha
        state.y += dy * alpha
    }
    return state
}
